module.exports = __webpack_public_path__ + "static/media/industries-fertilizer-s.cc659cd6.webp";